const $ = jQuery;

const Exapnd = {
  init: function () {
    const buttonEl = document.querySelector(".more-details");

    if (buttonEl)
      buttonEl.addEventListener("click", function () {
        console.log("click");

        buttonEl.classList.toggle("active");
      });
  },
};

export default Exapnd;
